document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Mobile navigation ---------- */
  var navToggle = document.querySelector('[data-nav-toggle]');
  var navClose = document.querySelector('[data-nav-close]');
  var mobileNav = document.querySelector('[data-mobile-nav]');

  function openNav() {
    if (!mobileNav) return;
    mobileNav.classList.add('is-open');
    mobileNav.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeNav() {
    if (!mobileNav) return;
    mobileNav.classList.remove('is-open');
    mobileNav.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  if (navToggle) navToggle.addEventListener('click', openNav);
  if (navClose) navClose.addEventListener('click', closeNav);

  /* ---------- Quantity selectors ---------- */
  document.querySelectorAll('[data-qty-selector]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    var minus = wrap.querySelector('[data-qty-minus]');
    var plus = wrap.querySelector('[data-qty-plus]');
    if (!input) return;
    if (minus) minus.addEventListener('click', function () {
      var v = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
    if (plus) plus.addEventListener('click', function () {
      var v = (parseInt(input.value, 10) || 1) + 1;
      input.value = v;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });

  /* ---------- Product media thumbnail swap ---------- */
  document.querySelectorAll('[data-product-thumbs]').forEach(function (thumbList) {
    var mainImg = document.querySelector('[data-product-main-image]');
    thumbList.querySelectorAll('img').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!mainImg) return;
        mainImg.src = thumb.dataset.full || thumb.src;
        thumbList.querySelectorAll('img').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });
  });

  /* ---------- Cart line quantity auto-submit on change ---------- */
  document.querySelectorAll('[data-cart-qty]').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('form');
      if (form) form.submit();
    });
  });

  /* ---------- Testimonial "read more" detection ---------- */
  var checkTestimonialTruncation = function () {
    document.querySelectorAll('.testimonial-card__quote').forEach(function (quoteEl) {
      var card = quoteEl.closest('.testimonial-card');
      if (!card) return;
      var isTruncated = quoteEl.scrollHeight > quoteEl.clientHeight + 2;
      card.classList.toggle('is-truncated', isTruncated);
    });
  };
  checkTestimonialTruncation();
  window.addEventListener('load', checkTestimonialTruncation);
  window.addEventListener('resize', checkTestimonialTruncation);

  /* ---------- Testimonial carousel ---------- */
  document.querySelectorAll('[data-testimonial-scroll]').forEach(function (track) {
    var wrap = track.closest('.testimonial-scroll-wrap');
    if (!wrap) return;
    var prevBtn = wrap.querySelector('[data-testimonial-prev]');
    var nextBtn = wrap.querySelector('[data-testimonial-next]');
    var scrollByCard = function (direction) {
      var card = track.querySelector('.testimonial-card');
      var amount = card ? card.getBoundingClientRect().width + 24 : track.clientWidth * 0.8;
      track.scrollBy({ left: amount * direction, behavior: 'smooth' });
    };
    if (prevBtn) prevBtn.addEventListener('click', function () { scrollByCard(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { scrollByCard(1); });
  });

  /* ---------- Collection filter drawer (mobile) ---------- */
  var filtersPanel = document.getElementById('CollectionFilters');
  var filtersToggle = document.getElementById('CollectionFiltersToggle');
  var filtersClose = document.getElementById('CollectionFiltersClose');

  function openFilters() {
    if (!filtersPanel) return;
    filtersPanel.classList.add('is-open');
    if (filtersToggle) filtersToggle.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
  }
  function closeFilters() {
    if (!filtersPanel) return;
    filtersPanel.classList.remove('is-open');
    if (filtersToggle) filtersToggle.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
  }
  if (filtersToggle) filtersToggle.addEventListener('click', openFilters);
  if (filtersClose) filtersClose.addEventListener('click', closeFilters);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeFilters();
  });

  /* ---------- Header scroll shadow ---------- */
  var header = document.querySelector('.site-header');
  if (header) {
    var onScroll = function () {
      if (window.scrollY > 8) {
        header.style.boxShadow = '0 6px 18px rgba(42,51,31,0.06)';
      } else {
        header.style.boxShadow = 'none';
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }
});
